import type { Dispatch, FC, PropsWithChildren, SetStateAction } from 'react';
import { useEffect } from 'react';

interface FallbackProps extends PropsWithChildren {
  setSuspended: Dispatch<SetStateAction<boolean>>;
}

const Fallback: FC<FallbackProps> = ({ children, setSuspended }) => {
  useEffect(() => {
    setSuspended(true);

    return () => setSuspended(false);
  }, [setSuspended]);

  return <>{children}</>;
};

export default Fallback;
